export const pt = {
  "BACK_BUTTON": "Voltar",
  "NEXT_BUTTON": "Próximo",
  "FINISH_BUTTON": "Concluir",
  "CHOICES_TITLE": "Escolhas",
  "SELECT_INPUT": "Selecione",
  "MULTICHOICE_PEER_PLACEHOLDER": "Selecione pessoa(s)",
  "MULTICHOICE_PEER_REQUIRED_ERROR": "Selecione pelo menos uma pessoa.",
  "MULTICHOICE_OTHER_LABEL": "Outro (especifique)",
  "MULTICHOICE_OTHER_PLACEHOLDER": "Especifique",
  "MULTICHOICE_OTHER_TEXT_REQUIRED": "Especifique sua resposta para \"Outro\".",
  "MULTICHOICE_OTHER_TEXT_TOO_LONG": "Sua resposta deve ter no máximo 1000 caracteres.",
  "MULTICHOICE_CLEAR_SELECTION": "Limpar seleção",
  "LIKERT_HINT": "Selecione uma pessoa e atribua uma pontuação.",
  "LIKERT_SCORE_LABEL": "Pontuação",
  "LIKERT_INCOMPLETE_ERROR": "Selecione pessoa e pontuação em cada linha.",
  "LIKERT_INVALID_ERROR": "Uma ou mais pontuações estão fora do intervalo permitido.",
  "EMPTY_ERROR": "Campo obrigatório!",
    "SUBMIT_ERROR": "Nao foi possivel enviar as respostas. Revise suas respostas.",
  "SENDING_DATA": "dados enviados!",
  "LOADING": "Carregando...",
  "MAX_SELECT_ERROR": "O limite máximo é ",
  "FORM_ALREADY_ANSWERED": "A pesquisa foi respondida!",
  "THANK_YOU": "Obrigado!",
  "MAX_SELECT_CUSTOM_MESSAGE": "Você atingiu o valor da opção máxima",
  "SKILL_PLACEHOLDER": "Nível de habilidade",
  "QR_SELECT_TITLE": "Selecione seu nome",
  "QR_SELECT_PLACEHOLDER": "Pesquise seu nome...",
  "QR_NO_PARTICIPANTS": "Nenhum participante disponível. Todos os participantes já responderam.",
  "QR_SURVEY_NOT_FOUND": "Pesquisa não encontrada",
  "QR_LOAD_ERROR": "Não foi possível carregar os participantes. Por favor, tente novamente.",
  "QR_PARTICIPANT_ALREADY_ANSWERED": "Este participante já concluiu a pesquisa. Por favor, volte e selecione seu nome novamente.",
  "QR_BACK_TO_SELECTION": "Voltar à seleção de nome",
  "companyValues": {
    "PASSION": "Paixão por tudo o que fazemos",
    "INNOVATING": "Sempre inovando",
    "CONFIDENCE": "Com confiança e responsabilidade",
    "WINNING": "Vencendo como uma equipe",
    "DIFFERENCE": "Comprometido em fazer a diferença"
  }
}

